
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NavItem extends Vue {
  @Prop({ default: '' }) icon!: string;

  @Prop({ default: null }) iconComponent!: Record<string, unknown> | null;

  @Prop({ default: '' }) to!: string;

  @Prop({ default: false }) mini!: boolean;

  @Prop({ default: undefined }) id!: string | undefined;
}
